export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10965.3c7b88c3.jpg";